module.exports = __webpack_public_path__ + "img/leonardo.c43f7f7e.png";